import { TopMenuView } from '../components/scheduling/ViewMenu';
import { SchedulingQueryParams } from '../store/mst/Router/constants';
import getSelectedView from './getSelectedView';

// Query-param patch applied when the selected date changes. The view param is
// cleared (undefined → the router deletes it) on a plain date toggle so the
// tab-matches-date rule re-decides for the new date (ROUT-3258); the rule
// restores the stored per-tab sub-view, so a cleared view never loses the
// user's list/timeline preference (ROUT-2644). An explicit `view` is resolved
// to its concrete sub-view and kept (e.g. the Customers toast, ROUT-2468).
export const buildDateToggleParams = (
  date: string | undefined,
  view?: TopMenuView,
  allowUnscheduledViews: boolean = true,
) => ({
  [SchedulingQueryParams.DATE]: date,
  [SchedulingQueryParams.VIEW]: view ? getSelectedView(view, { allowUnscheduledViews }) : undefined,
});
